import { ListingPage, NotFound } from '@boozt/app/components/pages';
import { AppProvider } from '@boozt/app/context';
import type { AppProps } from '@boozt/types';

import '../styles/global.scss';

const routes = {
    listing: ListingPage,
    not_found: NotFound,
};

export default function Content(app: AppProps) {
    const { page } = app;
    const { route } = page;
    const Page = routes?.[route];

    return (
        <AppProvider app={app}>
            {Page && <Page />}
        </AppProvider>
    );
}
